module.exports = __webpack_public_path__ + "media/images/vector-10@2x-3bbb826be1dbdd6a375f923eb39080cd.png";